// Ordered biggest-first (maxres 1280x720, standard 640x480, high 480x360,
// medium 320x180, default 120x90). `fhd` is deliberately excluded: the
// YouTube Data API reports it (1920x1080) but the underlying fhddefault.jpg
// is never actually served (i.ytimg.com 404s on it for every video we've checked).
const THUMBNAIL_SIZES = ['maxres', 'standard', 'high', 'medium', 'default'];
export function getThumbnail(thumbnails) {
    if (!thumbnails) {
        return undefined;
    }
    const biggestAvailableSize = THUMBNAIL_SIZES.find((size) => thumbnails[size]?.url);
    const biggestThumbnail = biggestAvailableSize
        ? thumbnails[biggestAvailableSize]
        : undefined;
    return biggestThumbnail?.url;
}
export default getThumbnail;
//# sourceMappingURL=get-thumbnail.js.map